import { memo } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Box,
} from "@mui/material";
import ModernCard from "./ModernCard";
import PropTypes from "prop-types";

const TableCard = memo(
  ({
    title,
    data,
    keys,
    subtitles,
    icon: Icon,
    t,
    renderActions,
    color = "primary",
  }) => (
    <ModernCard title={title} icon={Icon} color={color}>
      <TableContainer>
        <Table
          size="small"
          aria-label={t("documentDetail.tableAria", { title })}
        >
          <TableHead>
            <TableRow>
              {subtitles.map((subtitle, index) => (
                <TableCell key={index}>
                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                    color="text.primary"
                  >
                    {subtitle}
                  </Typography>
                </TableCell>
              ))}
              {renderActions && (
                <TableCell>
                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                    color="text.primary"
                  >
                    {t("documentDetail.actions")}
                  </Typography>
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? (
              data.map((item, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:hover": {
                      bgcolor: "action.hover",
                    },
                    "&:nth-of-type(odd)": {
                      bgcolor: "action.hover",
                    },
                  }}
                >
                  {keys.map((key) => (
                    <TableCell key={key}>
                      <Typography variant="body2">
                        {item[key] || t("documentDetail.na")}
                      </Typography>
                    </TableCell>
                  ))}
                  {renderActions && (
                    <TableCell>{renderActions(item)}</TableCell>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={keys.length + (renderActions ? 1 : 0)}>
                  <Box sx={{ textAlign: "center", py: 4 }}>
                    <Typography variant="body2" color="text.secondary">
                      {t("documentDetail.noDataAvailable")}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </ModernCard>
  )
);

TableCard.displayName = "TableCard";

TableCard.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  keys: PropTypes.array.isRequired,
  subtitles: PropTypes.array.isRequired,
  icon: PropTypes.elementType,
  t: PropTypes.func.isRequired,
  renderActions: PropTypes.func,
  color: PropTypes.string,
};

export default TableCard;
